/**
 * 방화벽 그룹 관리 store
 * Ipv4, Ipv6
 *
 * @since 2018-06-08
 * @author kdydesign.kim
 */

import {CmApiPrefix as objApiPrefix} from 'utils'

// 그룹 데이터
const initGroupData = () => {
  return {
    name: void 0,
    desc: void 0
  }
}

export const state = () => ({
  version: 4,
  groupList: [],
  groupData: initGroupData(),
  selectedGroupData: void 0
})

export const mutations = {
  // 방화벽 IP Version 설정
  setIpVersion (state, version) {
    state.version = version
  },

  // 그룹 목록 조회
  getGroupList (state, data) {
    state.groupList = Object.freeze(data)
  },

  // 그룹 추가
  saveGroupData (state, data) {
    const groupList = _.cloneDeep(state.groupList)

    groupList.push(data)
    state.groupData = initGroupData()

    state.groupList = Object.freeze(groupList)
  },

  // 그룹 조회
  getGroupData (state, data) {
    state.groupData = data
  },

  // 그룹 수정
  updateGroup (state, data) {
    const groupList = _.map(state.groupList, (o) => {
      if (o.fw_grp_id === data.fw_grp_id) {
        o = data
      }
      return o
    })

    state.groupList = Object.freeze(groupList)
  },

  // 그룹 삭제
  deleteGroup (state, groupId) {
    const groupList = _.cloneDeep(state.groupList)
    const itemIndex = _.findIndex(state.groupList, {fw_grp_id: groupId})

    groupList.splice(itemIndex, 1)

    state.groupList = Object.freeze(groupList)
  },

  // 그룹 선택 설정
  selectGroupData (state, data) {
    state.selectedGroupData = data
  },

  // 그룹 데이터 초기화
  resetGroupData (state) {
    state.groupData = initGroupData()
  }
}

export const actions = {
  // 방화벽 IP Version 설정
  setIpVersion ({commit}, {version}) {
    commit('setIpVersion', version)
  },

  // 그룹 목록 조회
  async getGroupList ({commit, state}) {
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/fw/${state.version}/groups`)

    if (code === 'ok') {
      commit('getGroupList', result)
    }
  },

  // 그룹 추가
  async saveGroupData ({commit, state, dispatch}) {
    const {code, result} = await this.$axios.$post(`${objApiPrefix}/fw/${state.version}/groups`, state.groupData)

    if (code === 'ok') {
      commit('saveGroupData', result)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },

  // 그룹 조회
  async getGroupData ({commit, state}) {
    const groupId = state.selectedGroupData.fw_grp_id
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/fw/${state.version}/groups/${groupId}`)

    if (code === 'ok') {
      commit('getGroupData', result)
    }
  },

  // 그룹 수정
  async updateGroup ({commit, state, dispatch}, {srcGroupId, tarGroupId}) {
    let groupId = void 0
    let groupData = state.groupData

    if (srcGroupId && tarGroupId) {
      groupData = {
        pre_grp_id: tarGroupId,
        up_down: 2
      }

      groupId = srcGroupId
    } else {
      groupId = state.selectedGroupData.fw_grp_id
    }
    const {code, result} = await this.$axios.$put(`${objApiPrefix}/fw/${state.version}/groups/${groupId}`, groupData)

    if (code === 'ok') {
      commit('updateGroup', result)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },

  // 그룹 삭제
  async deleteGroup ({commit, state, dispatch}) {
    const groupId = state.selectedGroupData.fw_grp_id
    const {code} = await this.$axios.$delete(`${objApiPrefix}/fw/${state.version}/groups/${groupId}`)

    if (code === 'ok') {
      commit('deleteGroup', groupId)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  }
}

export const getters = {
  // selectbox 형태의 group list
  selectTypeGroupList (state) {
    const groupList = state.groupList
    const resultArr = []
    for (let i = 0; i < groupList.length; i++) {
      const grpName = groupList[i].fw_grp_uname
      if (grpName === 'top' || grpName === 'bottom') {
        const resultObj = {}
        resultObj.label = grpName
        resultObj.value = groupList[i].fw_grp_id
        resultArr.push(resultObj)
      }
    }
    return resultArr
  }
}

export const strict = false
